import TokenManager from '@zeeve-platform/login-utility';
import { AlertsTable, ComparisonType, FieldName } from '@zeeve-platform/alerts-ui';
import { useSearchParams } from 'react-router-dom';
import BaseUrls from '../../utils/baseUrls';

type Filter = {
  fieldName: FieldName;
  val: string;
  compare: ComparisonType;
}
const AlertsBody = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const columns: FieldName[] = ['alertId', 'alertName', 'nodeId', 'networkId', 'severity', 'alertType', 'component', 'status', 'alertTimestamp'];
  const filters: FieldName[] = columns.filter((fieldName: FieldName) => {
    if (searchParams.has(fieldName)) {
      return true;
    } return false;
  });

  const filterObject: Filter[] = filters.map((fieldName: FieldName) => ({
    fieldName,
    val: searchParams.get(fieldName) as string,
    compare: 'equal',
  }));
  return (

    <section className="px-5 col-12 workspace">
      <div className="cardBlack">
        <div className="card p-2 cardBorder shadow-sm mt-4">
          {' '}
          <div className=" p-2">
            {' '}
            <AlertsTable
              heading="Common Alerts"
              TokenManager={TokenManager}
              alertsBackendUrl={BaseUrls.getAlertsBackendUrl()}
              columns={columns}
              queryParams={filterObject}
            />
            {' '}
          </div>
          {' '}
        </div>
      </div>
    </section>
  );
};

export default AlertsBody;